import { useState, useEffect } from "react";
import axiosInstance from "../axiosInstance";

/**
 * Custom hook to fetch and manage user credit data
 * @returns {Object} - Object containing user credit data and related functions
 */
const useUserCreditData = () => {
  const [userCredits, setUserCredits] = useState({
    available: 0,
    used: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUserInfo = () => {
    setIsLoading(true);
    setError(null);

    let Req = {
      method: "GET",
      baseURL:
        window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization:
          "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axiosInstance(Req)
      .then((Res) => {
        setUserCredits({
          available: Res.data.userCredit.balance,
          used: Res.data.userCredit.creditSpent,
        });
        setIsLoading(false);
      })
      .catch((Err) => {
        console.error("Error fetching user credit data:", Err);
        setError(Err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return {
    userCredits,
    isLoading,
    error,
    refetchCredits: fetchUserInfo,
  };
};

export default useUserCreditData;
